export const LOADING_WAREHOUSE = "LOADING_WAREHOUSE";
export const GET_WAREHOUSE_LIST = "GET_WAREHOUSE_LIST";
export const REMOVE_WAREHOUSE = "REMOVE_WAREHOUSE";
export const ADD_WAREHOUSE = "ADD_WAREHOUSE";
export const UPDATE_WAREHOUSE = "UPDATE_WAREHOUSE";
export const GET_WAREHOUSE_BY_ID = "GET_WAREHOUSE_BY_ID";